import React, { useState } from 'react';
import { Grid, Button, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DataGrid } from '@mui/x-data-grid';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import apiClient from '../ApiClient/ApiClient';

export default function Buyer({ data }) {
  const [needDate, setNeedDate] = useState(null);
  const [drawNum, setDrawNum] = useState('');
  const [OlddrawNum, setOldDrawNum] = useState('');
  const [piNum, setPiNum] = useState('');
  const [purchaseRows, setPurchaseRows] = useState(data?.buyerDtos || []);
  const [cardRows, setCardRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buyDate, setBuyDate] = useState(null);
  const [orderNum,setOrderNum]= useState('');

  // 欄位結構轉為 DataGrid 格式
  const columns1 = [
    { field: 'needDate', headerName: '需求日期', width: 105,
    // 加上這段，會自動格式化時間成 yyyy/MM/dd
    valueFormatter: (params) => {
        if (!params.value) return '';
        // 假設 value 可能是字串也可能是 Date 物件
        return dayjs(params.value).format('YYYY/MM/DD');
      }
     },
    { field: 'manufacturer', headerName: '廠商', width: 100 },
    { field: 'kind', headerName: '類別', width: 80 },
    { field: 'drawNum', headerName: '圖號', width: 110 },
    { field: 'itemName', headerName: '物品名', width: 120 },
    { field: 'unit', headerName: '單位', width: 60 },
    { field: 'amount', headerName: '數量', width: 80, valueFormatter: ({ value }) => Number(value).toFixed(2) },
    { field: 'unitPrice', headerName: '單價', width: 80, valueFormatter: ({ value }) => Number(value).toFixed(4) },
    { field: 'moneyAmount', headerName: '金額', width: 80, valueFormatter: ({ value }) => Number(value).toFixed(2) },
    { field: 'orderNum', headerName: '單號', width: 110 },
    { field: 'piNum', headerName: '批號', width: 110 },
    { field: 'approve', headerName: '核准', width: 120 },
    { field: 'id', headerName: 'ID', width: 100, hide: true },
  ];

  const columns2 = [
    { field: '日期', headerName: '日期', width: 140 },
    { field: '類別', headerName: '類別', width: 60 },
    { field: '單號', headerName: '單號', width: 110 },
    { field: '批號', headerName: '批號', width: 110 },
    { field: '入量', headerName: '入量', width: 90, valueFormatter: ({ value }) => Number(value).toFixed(2) },
    { field: '出量', headerName: '出量', width: 90, valueFormatter: ({ value }) => Number(value).toFixed(2) },
    { field: '庫存量', headerName: '庫存量', width: 90, valueFormatter: ({ value }) => Number(value).toFixed(2) },
    { field: '核准', headerName: '核准', width: 110 },
    { field: '領用', headerName: '領用', width: 80 },
  ];

  // 查詢
  const fetchMain = async () => {
    setLoading(true);
    try {
      const params = {
        needDate: needDate ? dayjs(needDate).format('YYYY-MM-DD') : '',
        buyDate: buyDate ? dayjs(buyDate).format('YYYY-MM-DD') : '',
        drawNum,
        piNum,
        orderNum,
        page: 1,
      };
      const res = await apiClient.get(`/Buyer/GetMains`, { params });
      setPurchaseRows(res.data.buyerDtos ?? []);
      setCardRows([]); // 查詢時自動清空下方窗格
    } finally {
      setLoading(false);
    }
  };

  // 依圖號查資材卡
  const fetchCard = async (drawNum) => {
    // if (OlddrawNum === drawNum) return;
    // setOldDrawNum(drawNum);
    setLoading(true);
    try {
      const res = await apiClient.get(`/Buyer/GetCard?drawNum=${drawNum}`);
      setCardRows(res.data?.length > 0 ? res.data : []);
    } finally {
      setLoading(false);
    }
  };

  // 上表雙擊
  const handleCellDoubleClick = async (params) => {
    if (params.field !== 'approve') {
      fetchCard(params.row.drawNum);
      return;
    }
  
    const rowId = params.row.id;
    const userName = sessionStorage.getItem('userName');
    const todayMMDD = dayjs().format('MM/DD');
  
    // 找到主表當前 row
    const currentRow = purchaseRows.find(row => row.id === rowId);
    let newApprove = '';
  
    if (!currentRow.approve || currentRow.approve === '' || currentRow.approve === null) {
      newApprove = `${userName}${todayMMDD}`;
    } else if (currentRow.approve === `${userName}${todayMMDD}`) {
      newApprove = '駁回';
    } else if (currentRow.approve === '駁回') {
      newApprove = '';
    }
  
    // 1. 先更新主表 approve 狀態
    setPurchaseRows(prevRows =>
      prevRows.map(row =>
        row.id === rowId ? { ...row, approve: newApprove } : row
      )
    );
  
    // 2. 取得上表該行「單號、批號」
    const { orderNum, piNum } = currentRow; // 你欄位名可能是 orderNum/batchNum/piNum，請對照修正
  
    // 3. 更新下表相符資料的核准
    setCardRows(prevRows =>
      prevRows.map(row =>
        // 這裡假設下表的單號、批號欄位名為「單號」、「批號」
        row.單號 === orderNum && row.批號 === piNum
          ? { ...row, 核准: newApprove }
          : row
      )
    );
  };
  
  

  // 下表選取
  const handleSelectAll = () => {
    const userName = sessionStorage.getItem('userName');
    const todayMMDD = dayjs().format('MM/DD');
    const approveValue = `${userName}${todayMMDD}`;
    setPurchaseRows(prevRows =>
      prevRows.map(row => ({
        ...row,
        approve: approveValue
      }))
    );
  };
  
  const handleDeselectAll = () => {
    setPurchaseRows(prevRows =>
      prevRows.map(row => ({
        ...row,
        approve: ''
      }))
    );
  };
  
  const handleSign = async () => {
    if (!purchaseRows.length) {
      alert('無資料可傳送');
      return;
    }
  
    try {
      setLoading(true);
      // 假設你的API為 /Buyer/BatchSignAll
      await apiClient.post(`/Buyer/BatchSignAll`, purchaseRows);
  
      alert('所有資料已送出');
      // 如有需要可重查/清空狀態
      // fetchMain();
    } catch (err) {
      alert('傳送失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  };
  
  const handleCheckboxChange = (selection) => setSelectedRows(selection);

// 需求日期 onChange
const handleNeedDateChange = (value) => {
  setNeedDate(value);
  if (value) {
    setBuyDate(null);
    setPiNum('');
  }
};

// 採購日期 onChange
const handleBuyDateChange = (value) => {
  setBuyDate(value);
  if (value) {
    setNeedDate(null);
    setPiNum('');
  }
};

// 單號 onChange
const handlePiNumChange = (e) => {
  const value = e.target.value;
  setPiNum(value);
  if (value) {
    setNeedDate(null);
    setBuyDate(null);
  }
};

const handleOrderNumChange = (e) => {
  const value = e.target.value;
  setOrderNum(value);
  if (value) {
    setNeedDate(null);
    setBuyDate(null);
  }
};

  return (
    <div className='container-fluid'>
        {/* 全畫面讀取遮罩 */}
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
      {/* 查詢區 */}
      <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
      <Grid item xs={2.4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="需求日"
              value={needDate}
              onChange={handleNeedDateChange}
              slotProps={{ textField: { fullWidth: true, size: "small" } }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={2.4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="採購日期"
              value={buyDate}
              onChange={handleBuyDateChange}
              slotProps={{ textField: { fullWidth: true, size: "small" } }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={2.4}>
          <TextField label="批號" value={piNum} onChange={handlePiNumChange} fullWidth size="small" />
        </Grid>
        <Grid item xs={2.4}>
          <TextField label="單號" value={orderNum} onChange={handleOrderNumChange} fullWidth size="small" />
        </Grid>
        <Grid item xs={2.4}>
          <Button variant="contained" onClick={fetchMain} fullWidth>查詢</Button>
        </Grid>
      </Grid>

      {/* 上表：主資料 */}
      <div style={{ height: 300, width: '100%', marginBottom: 16 }}>
      <DataGrid
        rows={purchaseRows}
        columns={columns1}
        loading={loading}
        pageSize={100}
        rowsPerPageOptions={[100]}
        pagination
        disableRowSelectionOnClick
        onCellDoubleClick={handleCellDoubleClick}
        getRowId={row => row.id}
        rowHeight={28}
        headerHeight={28} 
        sx={{ backgroundColor: '#fff' }}
        columnVisibilityModel={{
          id: false, // <-- 這裡明確關掉 id 欄位
        }}
        />
      </div>

      {/* 下表：資材卡 */}
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <div style={{ height: 280, width: '100%' }}>
          <DataGrid
            rows={cardRows.map((row, idx) => ({ id: row.pk ?? row.id ?? idx, ...row }))}
            columns={columns2}
            checkboxSelection={false}
            pageSize={100}
            rowsPerPageOptions={[100]}
            pagination
            loading={loading}
            disableRowSelectionOnClick
            rowHeight={28}
            headerHeight={28} 
            sx={{ backgroundColor: '#fff' }}
            getRowId={row => row.id}
        />

          </div>
        </Grid>
        {/* 右側操作按鈕 */}
        <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-end' }}>
          <Button variant="outlined" color="primary" fullWidth onClick={handleSelectAll}>全選</Button>
          <Button variant="outlined" color="secondary" fullWidth onClick={handleDeselectAll}>全部取消</Button>
          <Button
            variant="contained"
            color="success"
            fullWidth
            sx={{ fontWeight: 'bold', fontSize: 18, borderRadius: 4, boxShadow: 2 }}
            onClick={handleSign}
          >
            簽核
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
